var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-centerize"},[_c('v-checkbox',{attrs:{"disabled":_vm.disabled,"label":_vm.label},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}}),_c('AppTextTooltip',{staticClass:"pl-2 pb-1",attrs:{"tooltipText":_vm.tooltipMessage}},[_c('SIcon',{attrs:{"name":'circ-info'}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }